import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyPropertyLocationIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./PropertyLocationIcon-f5ef14c3.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyPropertyLocationIcon as P };
